import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { LanguageSwitcherContext } from "../context/languageSwitcherContext"

export const useMegaMenu = () => {
  const menu = useStaticQuery(graphql`
    query MegaMenuQuery {
      allDatoCmsMegaMenu(
        filter: { root: { eq: true }, anchor: { ne: null } }
        sort: { fields: position, order: ASC }
      ) {
        nodes {
          id
          locale
          root
          anchor
          position
          link {
            ... on DatoCmsInternalLink {
              id
              anchor
              locale
              model {
                apiKey
              }
              link {
                ... on DatoCmsEventPage {
                  ...EventPageDetails
                }
                ... on DatoCmsBlogPage {
                  ...BlogDetails
                }
                ... on DatoCmsPage {
                  ...PageDetails
                  ...PageTreeParent
                  ...AllSlugLocales
                }
                ... on DatoCmsArticle {
                  ...ArticleDetails
                  ...ArticleAllSlugLocales
                }
                ... on DatoCmsArticleCategory {
                  ...ArticleCategoryDetails
                  ...ArticleCategoryAllSlugLocales
                }
              }
            }
            ... on DatoCmsExternalLink {
              id
              anchor
              url
              model {
                apiKey
              }
            }
          }
          treeChildren {
            id
            locale
            root
            anchor
            position
            link {
              ... on DatoCmsInternalLink {
                id
                anchor
                locale
                model {
                  apiKey
                }
                link {
                  ... on DatoCmsEventPage {
                    ...EventPageDetails
                  }  
                  ... on DatoCmsBlogPage {
                    ...BlogDetails
                  }
                  ... on DatoCmsPage {
                    ...PageDetails
                    ...PageTreeParent
                    ...AllSlugLocales
                  }
                  ... on DatoCmsArticle {
                    ...ArticleDetails
                    ...ArticleAllSlugLocales
                  }
                  ... on DatoCmsArticleCategory {
                    ...ArticleCategoryDetails
                    ...ArticleCategoryAllSlugLocales
                  }
                }
              }
              ... on DatoCmsExternalLink {
                id
                anchor
                url
                model {
                  apiKey
                }
              }
            }
            story {
              ...StoryDetails
              ...StoryAllSlugLocales
            }
            treeChildren {
              id
              locale
              root
              anchor
              position
              link {
                ... on DatoCmsInternalLink {
                  id
                  anchor
                  locale
                  model {
                    apiKey
                  }
                  link {
                    ... on DatoCmsEventPage {
                      ...EventPageDetails
                    }    
                    ... on DatoCmsBlogPage {
                      ...BlogDetails
                    }
                    ... on DatoCmsPage {
                      ...PageDetails
                      ...PageTreeParent
                      ...AllSlugLocales
                    }
                    ... on DatoCmsArticle {
                      ...ArticleDetails
                      ...ArticleAllSlugLocales
                    }
                    ... on DatoCmsArticleCategory {
                      ...ArticleCategoryDetails
                      ...ArticleCategoryAllSlugLocales
                    }
                  }
                }
                ... on DatoCmsExternalLink {
                  id
                  anchor
                  url
                  model {
                    apiKey
                  }
                }
              }
              treeChildren {
                id
                locale
                root
                anchor
                position
                link {
                  ... on DatoCmsInternalLink {
                    id
                    anchor
                    locale
                    model {
                      apiKey
                    }
                    link {
                      ... on DatoCmsEventPage {
                        ...EventPageDetails
                      }      
                      ... on DatoCmsBlogPage {
                        ...BlogDetails
                      }
                      ... on DatoCmsPage {
                        ...PageDetails
                        ...PageTreeParent
                        ...AllSlugLocales
                      }
                      ... on DatoCmsArticle {
                        ...ArticleDetails
                        ...ArticleAllSlugLocales
                      }
                      ... on DatoCmsArticleCategory {
                        ...ArticleCategoryDetails
                        ...ArticleCategoryAllSlugLocales
                      }
                    }
                  }
                  ... on DatoCmsExternalLink {
                    id
                    anchor
                    url
                    model {
                      apiKey
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const locale = React.useContext(LanguageSwitcherContext).activeLocale

  const i18nMenu = menu.allDatoCmsMegaMenu.nodes.filter(
    link => link.locale === locale
  )

  i18nMenu.map(link => {
    if (link.treeChildren.length > 0) {
      link.treeChildren.sort((a, b) => a.position - b.position)
      link.treeChildren.map(link => {
        if (link.treeChildren.length > 0) {
          link.treeChildren.sort((a, b) => a.position - b.position)
          link.treeChildren.map(link => {
            if (link.treeChildren.length > 0) {
              link.treeChildren.sort((a, b) => a.position - b.position)
            }
          })
        }
      })
    }
  })

  return i18nMenu
}
